import app from 'flarum/app';
import {extend} from "flarum/extend";
import TextEditor from "flarum/components/TextEditor";
import PostStream from "flarum/components/PostStream";
import IndexPage from "flarum/components/IndexPage";
import UploadButton from "./components/UploadButton"; 
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe';

extend(TextEditor.prototype, 'toolbarItems', function(items) {
    if(!app.forum.attribute('sayiwen-upload.canUpload')) return;
	items.add('upload', (
	  <UploadButton composer={this.attrs.composer}></UploadButton>
	),20);
});
extend(PostStream.prototype, ['oncreate'], () => { 
    
    if(app.lightbox != null){
        app.lightbox.destroy();
    }
    app.lightbox = new PhotoSwipeLightbox({
        gallery: ".photoswipe",
        children: 'a',
        pswpModule: PhotoSwipe
    });
    app.lightbox.init();
    
    
});